"use client";

import * as X from "@/ui";

import { HeroSection } from "./1.Hero";
import { TravelersSection } from "./2.Travelers";
import { WhyChooseUsSection } from "./3.WhyChooseUs";
import { WhoIsItForSection } from "./4.WhoIsItFor";
import { HowItWorksSection } from "./5.HowItWorks";
import { PricingSection } from "./6.Pricing";
import { ContactSection } from "./7.Contact";

import { useShippingPage } from "@/providers/strapi/content/types/singleTypes/shipping-page";


export function ShippingPageClient(props: X.PageProps) {
  const [downloadModalOpen, setDownloadModalOpen] = X.useState(false);


  const travelerCard = useShippingPage('travelerCard');
  const satisfactionCard = useShippingPage('satisfactionCard')
  return (
    <>
      <X.MainLayout {...props}>
        <HeroSection {...props} />
        <TravelersSection {...props} onDownloadApp={() => setDownloadModalOpen(true)}
          travelerCard={travelerCard}
          satisfactionCard={satisfactionCard}
        />
        <WhyChooseUsSection {...props} />
        <WhoIsItForSection {...props} />
        <HowItWorksSection {...props} />
        <PricingSection {...props} />
        <ContactSection {...props} />
      </X.MainLayout>

      <X.DownloadModal
        {...props}
        onClose={() => setDownloadModalOpen(false)}
        isOpen={downloadModalOpen}
      />
    </>
  );
}
